import React from 'react';
import { Hero } from '../components/home/Hero';
import { BestSellers } from '../components/home/BestSellers';
import { CompareTypes } from '../components/home/CompareTypes';
import { BatteryAdvisor } from '../components/home/BatteryAdvisor';
import { ReviewsSection } from '../components/home/ReviewsSection';
import { BrandStrip } from '../components/home/BrandStrip';
export function Home() {
  return <>
      <Hero data-id="element-729" data-mp="1ziz7hfa191wx" />
      <div className="h-12 lg:h-16" aria-hidden="true" data-id="element-730" data-mp="1zjidpyqbm1v4" />
      <BestSellers data-id="element-731" data-mp="24gikycywpant" />
      <CompareTypes data-id="element-732" data-mp="24i3go5wyizn9" />
      <ReviewsSection data-id="element-733" data-mp="24hk7bdldhjku" />
      <BatteryAdvisor data-id="element-734" data-mp="24ivcnhuguze2" />
      <BrandStrip data-id="element-735" data-mp="29gd9waz4fq68" />
    </>;
}